exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".card-list[data-v-9c0ece9c]{text-align:left}.brands[data-v-9c0ece9c]{text-align:center;background-color:#fff}.brands-img[data-v-9c0ece9c]{max-height:100px;width:auto;margin:0 0 4vh}.brands-img-container[data-v-9c0ece9c]{padding:1% 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9c0ece9c","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home.vue
// module id = 23
// module chunks = 1